import React, { useMemo } from 'react';
import { useTable, useSortBy } from 'react-table';
import { stableOrderBy } from '../../../../service/tableSorting';
import { formatLocal, useDisplayTimezone } from '../../../../service/localTime';
import { StyledSorted } from '../../../League/components/LeagueScorers/styled';
import { StyledTableWrap, StyledTable, StyledTh, StyledTr, StyledTd, StyledEmpty, StyledTextButton } from './styled';

export default function UniverseTransferTable({ rows, onPlayer, onClub }) {
  useDisplayTimezone();
  const columns = useMemo(() => [
    { Header: 'Player', accessor: 'playerName' },
    { Header: 'From', accessor: 'fromName' },
    { Header: 'To', accessor: 'toName' },
    { Header: 'Type', accessor: (row) => row.isLoan ? 'Loan' : 'Transfer', id: 'type' },
    { Header: 'Fee', accessor: 'fee', sortType: 'basic', sortDescFirst: true },
    { Header: 'Date', accessor: (row) => row.createdAt ? new Date(row.createdAt).getTime() : 0, id: 'date', sortType: 'basic', sortDescFirst: true },
  ], []);
  const table = useTable({ columns, data: rows, orderByFn: stableOrderBy, disableMultiSort: true,
    autoResetSortBy: false, getRowId: (row) => row.id }, useSortBy);
  if (!rows.length) return <StyledEmpty>No completed transfers this season</StyledEmpty>;
  return <StyledTableWrap><StyledTable {...table.getTableProps()}>
    <thead>{table.headerGroups.map((group) => <tr {...group.getHeaderGroupProps()}>
      {group.headers.map((column) => <StyledTh {...column.getHeaderProps()} aria-sort={column.isSorted ? column.isSortedDesc ? 'descending' : 'ascending' : 'none'}>
        <StyledTextButton {...column.getSortByToggleProps()}>{column.render('Header')}<StyledSorted $dir={column.isSorted ? column.isSortedDesc ? 'desc' : 'asc' : undefined} /></StyledTextButton>
      </StyledTh>)}
    </tr>)}</thead>
    <tbody {...table.getTableBodyProps()}>{table.rows.map((row) => {
      table.prepareRow(row);
      const item = row.original;
      return <StyledTr {...row.getRowProps()}>{row.cells.map((cell) => <StyledTd {...cell.getCellProps()}>
        {cell.column.id === 'playerName' ? <StyledTextButton disabled={!item.playerId} onClick={() => onPlayer(item)}>{item.playerName}</StyledTextButton>
          : cell.column.id === 'fromName' ? <StyledTextButton disabled={!item.fromId} onClick={() => onClub({ _id: item.fromId, name: item.fromName })}>{item.fromName}</StyledTextButton>
          : cell.column.id === 'toName' ? <StyledTextButton disabled={!item.toId} onClick={() => onClub({ _id: item.toId, name: item.toName })}>{item.toName}</StyledTextButton>
          : cell.column.id === 'fee' ? item.feeLabel
          : cell.column.id === 'date' ? item.createdAt ? formatLocal(item.createdAt, 'D MMM YYYY') : '—'
          : cell.render('Cell')}
      </StyledTd>)}</StyledTr>;
    })}</tbody>
  </StyledTable></StyledTableWrap>;
}
